import { jsx, jsxs } from "react/jsx-runtime";
function EmptySearch() {
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 120 120",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M95.25 45H8.25V108H98.25V48C98.25 46.3431 96.9069 45 95.25 45Z",
                fill: "#F0F3F7"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M108.2 57H24.0592C22.698 57 21.5074 57.9165 21.1591 59.2323L8.25 108H98.25L111.095 60.7876C111.614 58.8796 110.177 57 108.2 57Z",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M8.25 36C8.25 34.3431 9.59315 33 11.25 33L34.0074 33C34.803 33 35.5661 33.3161 36.1287 33.8787L47.25 45L8.25 45V36Z",
                fill: "#F0F3F7"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M29.9995 85.5L65.2495 85.5",
                stroke: "white",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M27 95.25L47.25 95.25",
                stroke: "white",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "89.25",
                cy: "30",
                r: "21",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M111.175 54.5758C111.907 55.3081 113.094 55.3081 113.826 54.5758C114.559 53.8436 114.559 52.6564 113.826 51.9242L111.175 54.5758ZM101.05 44.4508L111.175 54.5758L113.826 51.9242L103.701 41.7992L101.05 44.4508Z",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "89.25",
                cy: "30",
                r: "19.5",
                stroke: "#AFB9C9",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M100.5 27C100.5 26.0151 100.306 25.0398 99.9291 24.1299C99.5522 23.2199 98.9997 22.3931 98.3033 21.6967C97.6069 21.0003 96.7801 20.4478 95.8701 20.0709C94.9602 19.694 93.9849 19.5 93 19.5",
                stroke: "#AFB9C9",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M111.038 60.7842C111.554 58.877 110.118 57 108.142 57H98.25V108L111.038 60.7842Z",
                fill: "#F0F3F7"
            })
        ]
    });
}
export { EmptySearch as default };
